module.exports = __webpack_public_path__ + "static/media/boat.2787d787.png";